import { render, staticRenderFns } from "./Generales.vue?vue&type=template&id=6970248c&scoped=true&lang=html&"
import script from "./Generales.vue?vue&type=script&lang=js&"
export * from "./Generales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6970248c",
  null
  
)

export default component.exports